// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-rewriter.js?{"id":"data-v-717f98d6","scoped":true,"hasInlineConfig":false}!./src/components/common/chat-panel/ChatInputBar.css
// module id = IVaU
// module chunks = 1